export const PERMISSAO_USUARIO = 'PERMISSAO_USUARIO';
export const permissaoUsuario = (role) => ({
  type: PERMISSAO_USUARIO,
  payload: {
    role,
  },
});

export const ATUALIZAR_USUARIO = 'ATUALIZAR_USUARIO';
export const atualizarUsuario = (user) => ({
  type: ATUALIZAR_USUARIO,
  payload: {
    role: user.role,
    usuario: user.usuario,
    usuarioId: user.usuarioId,
    medicoId: user.medicoId,
    medico: user.medico,
    isResidente: user.isResidente,
  },
});



// WEBPACK FOOTER //
// ./src/app/common/usuario/usuario.action.js